import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	NumberField,
	DateField,
	ReferenceField,
	Edit,
	SimpleForm,
	TextInput,
	SelectInput,
	Filter,
} from 'react-admin';

const payoutStatusChoices = [
	{ id: 'requested', name: 'Demandé' },
	{ id: 'paid', name: 'Payé' },
];

const PayoutFilter: React.FC = (props: any) => (
	<Filter {...props}>
		<SelectInput source="status" choices={payoutStatusChoices} alwaysOn />
	</Filter>
);

// #region PayoutList
export const PayoutList: React.FC = (props: any) => (
	<List {...props} filters={<PayoutFilter />} sort={{ field: 'requested_at', order: 'DESC' }}>
		<Datagrid rowClick="edit">
			<ReferenceField source="partnerId" reference="partners" label="Partenaire" link={false}>
				<TextField source="name" />
			</ReferenceField>
			<NumberField source="amount" label="Montant" options={{ style: 'currency', currency: 'EUR' }} />
			<TextField source="status" label="Statut" />
			<TextField source="iban" label="IBAN" />
			<TextField source="invoiceUrl" label="Facture" />
			<DateField source="requestedAt" label="Demandé le" />
			<DateField source="paidAt" label="Payé le" />
		</Datagrid>
	</List>
);
// #endregion

// #region PayoutEdit — dépôt du lien de facture + passage à "payé"
export const PayoutEdit: React.FC = (props: any) => (
	<Edit {...props}>
		<SimpleForm>
			{/* Coordonnées COPIÉES à la demande : c'est sur celles-ci qu'on vire, jamais sur
			    l'IBAN courant du partenaire. Vides pour les demandes antérieures au 2026-11-02. */}
			<TextInput source="holderName" label="Titulaire" disabled fullWidth />
			<TextInput source="iban" label="IBAN" disabled fullWidth />
			<TextInput source="bic" label="BIC" disabled />
			<TextInput source="invoiceUrl" label="Lien facture de règlement" fullWidth />
			<SelectInput
				source="status"
				label="Statut"
				choices={payoutStatusChoices}
				helperText="Passer à « Payé » règle les commissions rattachées"
			/>
		</SimpleForm>
	</Edit>
);
// #endregion
